module.exports = __webpack_public_path__ + "img/home.411533cf.png";